import { Component, OnInit, AfterViewInit, Input, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AdminService } from '../../service/admin.service';
import { UtilService } from '../../service/util.service';
import * as constants from '../../app.constants';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import { NotificationsService } from 'angular2-notifications';
import { PagerService } from '../../pipe/pagination';
import { Ticket } from '../../model/ticket';
import { User } from '../../model/user';
import { Category } from '../../model/category';
import { Currency } from '../../model/currency';
import { Location } from '../../model/location';
import { Price } from '../../model/price';
import { ProfileImage } from '../../model/profile_image';
import { ErrorResponse } from '../../model/error-response';

declare let $: any;

@Component({
  selector: 'tickets-log',
  template: require('./ticket-log.component.html'),
  styles: [require('./ticket-log.component.css'), require('./table-scroll.css')]
})
export class TicketLogComponent implements OnInit, AfterViewInit {

  public tickets:any = [];
  public ticketType: number; // Type of ticket (All | Inactive | Fake)
  public page: number; // Current Page
  public pageSize: number; // Number of items per page
  public count: number; // Number of items in result
  public pager: any = {};
  public message: string = constants.messages.loading;
  public errorMsg: string;
  public pageSizes: number[];
  public showLoader: boolean;
  public ticketTypes = {
    1: 'All Tickets',
    2: 'Active Tickets',
    3: 'Inactive Tickets',
    4: 'Fake Tickets',
    5: 'Tickets Created By Admin',
    6: 'Fake Ticket Requests'
  };

  public location = '';
  public category = '';
  public title = '';
  public clearFilter = false;
  public searchRequest = '';

  // Fields related to update ticket
  @ViewChild('updateTicketModal') public updateTicketModal: ModalComponent;
  @ViewChild('approveRejectModal') public approveRejectModal: ModalComponent;
  public ticket: Ticket;
  public formErrors: any;
  public categories: Category[] = constants.categories;
  public ticketStatus: any = constants.ticketStatus;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public _notificationsService: NotificationsService,
    private adminService: AdminService,
    private pagerService: PagerService) {
    console.debug('constructor init fields');
    // Initialize fields
    this.page = 1;
    this.pageSize = 10;
    this.pageSizes = [10, 20, 50, 100];
    this.formErrors = {};
  }

  public ApplyFilters() {
    this.clearFilter = !(this.location.length === 0 && this.category.length === 0 && this.title.length === 0);
    this.searchRequest = '';
    if (this.location.length !== 0) {
      this.searchRequest = this.searchRequest + '&ticket__location__address=' + this.location;
    }
    if (this.category.length !== 0) {
      this.searchRequest = this.searchRequest + '&ticket__category__category_id=' + this.category;
    }
    if (this.title.length !== 0) {
      this.searchRequest = this.searchRequest + '&ticket__title=' + this.title;
    }
    this.getTickets(1);
  }

  public ClearFilters() {
    this.clearFilter = false;
    this.searchRequest = '';
    this.location = '';
    this.title = '';
    this.category = '';
    this.getTickets(1);
  }

  public ngOnInit(): void {
    this.page = 1;
    this.pageSize = 10;
    // Show tickets with default page number and size
    this.getTickets();
    // console.debug('Exiting TicketComponent.ngOnInit()');
  }

  public ngAfterViewInit(): void {
    // After view init
  }

  public onDateChanged(event, type) {
    console.debug(`onDateChanged type=${type}`);
    console.debug(`Local=${event.toLocaleString()}, UTC=${event.toISOString()}`);
    event.setSeconds(0);
    event.setMilliseconds(0);
  }

  public getTickets(selectedPage?: number, newPazeSize?: number): void {
    console.debug('Get list of tickets');
    selectedPage = selectedPage ? selectedPage : this.page;
    newPazeSize = newPazeSize ? newPazeSize : this.pageSize;
    let pageOptions = {
      page: selectedPage,
      page_size: newPazeSize
    };
    let searchRequest = '';
    if (this.searchRequest.length !== 0) {
      searchRequest = this.searchRequest;
    }

    let url = constants.URLs.ticketLog + '?page_size=' + newPazeSize + '&page_no=' + selectedPage + searchRequest;

    this.showLoader = true;
    this.adminService
      .getCall(url, true)
      .then((res) => {
        console.log('getTickets res');
        console.log(res);
        this.showLoader = false;
        this.count = res.count;
        this.tickets = res.results;
        this.message = null;
        this.page = selectedPage;
        this.pageSize = newPazeSize;
        this.pager = this.pagerService.getPager(this.count, selectedPage, newPazeSize);
      })
      .catch((error: any) => {
        console.error('TicketComponent- an error occurred', error);
        this.showLoader = false;
        try {
          this.errorMsg = error.json().error_msg || constants.messages.serverError;
        } catch (e) {
          this.errorMsg = error.message ? error.message : constants.messages.serverError;
        }
        this.adminService.showErrorToast(this.errorMsg);
      });
  }

  public goToPage(selectedPage: number) {
    if (this.pager.currentPage === selectedPage) {
      return;
    }
    if (selectedPage < 1 || selectedPage > this.pager.totalPages) {
      return;
    }
    // Show tickets with selected page number and existing page size
    this.getTickets(selectedPage);
  }

  public onPageSizeChange(newPazeSize: number): void {
    console.log(newPazeSize);
    this.getTickets(1, newPazeSize);
  }

  public markTicketFake(ticket: Ticket): void {
    console.debug(`markTicketFake ${ticket.ticket_id} is_flagged=${ticket.is_flagged}`);
    if (!ticket.is_flagged) {
      console.info('Ticket once flagged can\'t be reverted.');
      return;
    }
    let url = constants.URLs.markTicketFake.replace('{ticket_id}', ticket.ticket_id);
    console.debug(url);
    this.adminService
      .markTicketFake(url, {}, true)
      .then((res) => {
        console.log('markTicketFake res');
        console.log(res);
        if (res.status === 200) {
          this.adminService.showSuccessToast(constants.messages.userStatusUpdate);
          this.getTickets();
        }
      })
      .catch((error: any) => {
        ticket.is_flagged = !ticket.is_flagged; // Revert the change
        try {
          this.errorMsg = error.json().error_msg || constants.messages.serverError;
          console.debug('TicketComponent- an error occurred', error);
        } catch (e) {
          this.errorMsg = error.message ? error.message : constants.messages.serverError;
          console.error('TicketComponent- an error occurred', error);
        }
        this.adminService.showErrorToast(this.errorMsg);
      });
  }

  public cancelTicket(ticket: Ticket): void {
    console.debug(`cancelTicket ${ticket.ticket_id} isCancelled=${ticket.isCancelled}`);
    if (!ticket.isCancelled) {
      console.info('Ticket once cancelled can\'t be reverted.');
      return;
    }
    let url = constants.URLs.cancelTicket.replace('{user_id}', localStorage.getItem('userId'));
    url = url.replace('{ticket_id}', ticket.ticket_id);

    console.debug(url);
    this.adminService
      .cancelTicket(url, true)
      .then((res) => {
        console.log('cancelTicket res');
        console.log(res);
        if (res.status === 'success') {
          this.adminService.showSuccessToast(constants.messages.cancelTicket);
          this.getTickets();
        }
      })
      .catch((error: any) => {
        ticket.isCancelled = !ticket.isCancelled; // Revert the change
        try {
          this.errorMsg = error.json().error_msg || constants.messages.serverError;
          console.debug('TicketComponent- an error occurred', error);
        } catch (e) {
          this.errorMsg = error.message ? error.message : constants.messages.serverError;
          console.error('TicketComponent- an error occurred', error);
        }
        this.adminService.showErrorToast(this.errorMsg);
      });
  }

  public openUpdateTicketModal(ticketId: string = null): void {
    // alert('add or update');
    this.ticket = this.tickets.filter((tkt) => tkt.ticket_id === ticketId)[0];
    this.ticket = JSON.parse(JSON.stringify(this.ticket));
    this.ticket.category_id = this.ticket.category.category_id;
    this.errorMsg = null;
    this.formErrors = {};
    this.updateTicketModal.open();
  }

  public closeUpdateTicketModal(): void {
    this.updateTicketModal.close();
    this.ticket = null;
  }

  public updateTicket(): void {
    console.debug('Update Ticket');
    console.log(this.ticket);
    let url = constants.URLs.updateTicket.replace('{ticket_id}', this.ticket.ticket_id);
    console.debug(url);
    let model = {
      category: +this.ticket.category_id
    };
    this.showLoader = true;
    this.adminService
      .putCall(url, model, true)
      .then((res) => {
        console.log('Update Ticket res');
        console.log(res);
        this.showLoader = false;
        this.adminService.showSuccessToast(constants.messages.ticketUpdate);
        let ticket = this.tickets.filter((tkt) => tkt.ticket_id === this.ticket.ticket_id)[0];
        ticket.category = this.categories.filter((cat) => cat.category_id == this.ticket.category_id)[0];
        this.closeUpdateTicketModal();
      })
      .catch((error: any) => {
        this.showLoader = false;
        try {
          this.errorMsg = error.json().error_msg || constants.messages.serverError;
          console.debug('TicketComponent- an error occurred', error);
        } catch (e) {
          this.errorMsg = error.message ? error.message : constants.messages.serverError;
          console.error('TicketComponent- an error occurred', error);
        }
        this.adminService.showErrorToast(this.errorMsg);
      });
  }

  public openApproveRejectModal(tkt: Ticket): void {
    this.ticket = tkt;
    // this.addDummyUsers(this.ticket.flagged_by);
    this.errorMsg = null;
    this.approveRejectModal.open();
  }

  public closeApproveRejectModal(): void {
    this.approveRejectModal.close();
    this.ticket = null;
  }

  public approveRejectTicket(tkt: Ticket, action: string): void {
    console.log(`approveRejectTicket, action=${action}`);
    console.log(this.ticket);
    let flag: number;
    switch (action) {
      case 'approve':
        flag = 1;
        break;
      case 'reject':
        flag = 2;
        break;
      default:
        console.error(`Invalid action ${action}`);
        return;
    }
    let url = constants.URLs.approveRejectFakeTicketRequest.replace('{ticket_id}', this.ticket.ticket_id);
    console.debug(url);
    let model = {
      flag: flag
    };
    this.showLoader = true;
    this.adminService
      .approveRejectTicket(url, model, true)
      .then((res) => {
        console.log('Approve Reject Ticket res');
        console.log(res);
        this.showLoader = false;
        this.closeApproveRejectModal();
        let msg =
          flag === 1 ? constants.messages.fakeTicketRequestApproved : constants.messages.fakeTicketRequestRejected;
        this.adminService.showSuccessToast(msg);
        this.getTickets();
      })
      .catch((error: any) => {
        this.showLoader = false;
        try {
          this.errorMsg = error.json().error_msg || constants.messages.serverError;
          console.debug('approveRejectTicket- an error occurred', error);
        } catch (e) {
          this.errorMsg = error.message ? error.message : constants.messages.serverError;
          console.error('approveRejectTicket- an error occurred', error);
        }
      });
  }

  public getColspan(): number {
    let colspan;
    switch (this.ticketType) {
      case 2:
        colspan = 13;
        break;
      default:
        colspan = 13;
    }
    return colspan;
  }

  private addDummyUsers(users: any): User[] {
    users.push({name: 'User 1', email: 'user1@gmail.com', phone_number: '123'});
    users.push({name: 'User 2', email: 'user2@gmail.com', phone_number: '123'});
    users.push({name: 'User 3', email: 'user3@gmail.com', phone_number: '123'});
    users.push({name: 'User 4', email: 'user4@gmail.com', phone_number: '123'});
    users.push({name: 'User 5', email: 'user5@gmail.com', phone_number: '123'});
    users.push({name: 'User 6', email: 'user6@gmail.com', phone_number: '123'});
    users.push({name: 'User 7', email: 'user7@gmail.com', phone_number: '123'});
    return users;
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/manage/ticket-log/ticket-log.component.ts